import styled, { css } from 'styled-components';
import { gray, secondary, white } from '~/components/mixins/color';

export const Row = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
`;

export const CreateUpdateContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  height: 100%;

  .contents {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
  .form-data {
    display: flex;
    flex-direction: column;
    background: ${white.hex()};
    padding: 10px;
    padding-bottom: 0px;
    margin-bottom: 10px;
    flex: 0 0 auto;
  }
  .toolbar {
    display: flex;
    flex: 0 0 56px;
    min-height: 56px;
    height: 56px;
    padding: 0 10px;
    margin-top: 10px;
    background: ${white.hex()};
    align-items: center;
    justify-content: flex-end;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  min-height: 44px;
  min-height: 44px;
  padding: 0 15px;
  color:  ${gray.hex()};
  background: ${white.hex()};
  border-bottom: 1px solid ${secondary.hex()};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const FormToolbar = styled.div`
  display: flex;
  min-height: 56px;
  height: 56px;
  border-top: 1px solid ${secondary.hex()};

  .buttons {
    display: flex;
    padding-right: 10px;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  background: ${secondary.hex()};

  .list {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  .form {
    display: flex;
    position: relative;
    flex: 0 0 35%;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${white.hex()};
    color: ${gray.hex()};
    width: 100%;
    margin-left: 10px;
    border-radius: 3px;
    opacity: 0;
    transition: opacity 1s ease-out;

    section {
      padding: 10px;
    }
  }
  ${(props) =>
    props.showForm &&
    css`
      .form {
        opacity: 1;
      }
      @media (max-width: 1024px) {
        .list {
          display: none;
          visibility: hidden;
        }
        .form {
          flex: 1;
          margin-left: 0px;
        }
      }
      @media (min-width: 769px) and (max-width: 1024px) {
        .form {
          flex: 0 0 45%;
        }
      }
    `}
`;

